import * as z from "zod";

export const setFreeShippingCodes = {
  name: "setFreeShippingCodes" as const,
  input: z.object({ codes: z.array(z.string().trim().min(1)) }),
  output: z.object({ codes: z.array(z.string()) }),
};
